import { Box, useMediaQuery } from "@mui/material";
import { Stack } from "@mui/system";
import { Outlet } from "react-router-dom";
import NavBar from "./Navbar";
import SideDrawer from "./SideDrawer";
import { useAuthContext } from "../context/AuthContext";
import ComNavbar from "./ComNavbar";

export default function Layout() {
    const isLarge = useMediaQuery("(min-width: 600px)");
    const { ctxtUser } = useAuthContext();

    return (
        <Stack >
            {ctxtUser && (ctxtUser?.isComUser ? <ComNavbar /> : <NavBar />)}
            <Stack direction={'row'} sx={{ height: `calc(100vh - 55px)` }}>
                <SideDrawer />
                <Box alignItems='center' px={2.3} py={0.5} sx={{ width: isLarge ? "95.3vw" : "70rem" }} >
                    <Outlet />
                </Box>
            </Stack>
        </Stack>
    )
}
